import { Injectable } from '@angular/core';
import { SalesByPeriodCollectionQuery, SalesByPeriodCollectionQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalesByPeriodCollectionQuery)
@Wrapper(SalesByPeriodCollectionQueryHandlerBase)
export class SalesByPeriodCollectionQueryHandler {
    public constructor(
        http: Http,
        rootContext: RootContext
    ) { }
}
